// function to generate event schema
export const generateEventListSchema = (eventListForSchema = []) => { // artistList is an array of artists

    // Generate schema for offers, location, organizer, images, and performers
    let itemListElement = generateListForSchema(eventListForSchema?.events);

    // Construct the schema object
    let schema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": eventListForSchema?.name || "",
        "url": eventListForSchema?.url || "",
        "numberOfItems": eventListForSchema?.events?.length || 0,
        "itemListElement": itemListElement,
    };

    return schema;
};

// function to generate list for schema
export const generateListForSchema = (eventList = []) => {
    let itemListElement = [];
    eventList.forEach((event, index) => {
        itemListElement.push({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
                "@type": "Event",
                "name": event.name || "",
                "description": event.description || event.short_description || "",
                "startDate": event.dates[0]?.date || "",
                "endDate": event.dates[event.dates.length - 1]?.date || "",
                "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                "eventStatus": "https://schema.org/EventScheduled",
            }
        });
    });
    return itemListElement;
};
